import { pickQueryStringParamValueFromUrl, stripQueryStringParamFromUrl } from '../url'

export function pickAllApiKeysFromBotApiUrl(url: string): string[] {
  return pickQueryStringParamValueFromUrl(url, 'code', false)
}

export function pickApiKeyFromBotApiUrl(url: string): string {
  return pickAllApiKeysFromBotApiUrl(url)?.[0] || ''
}

export function stripSecretsFromBotApiUrl(url: string): string {
  return stripQueryStringParamFromUrl(url, 'code', false)
}

export enum AppKind {
  WebApp = 'webapp',
  FunctionApp = 'functionapp'
}
